<template>
  <div class="ic-sidebar">
    <div class="ic-sidebar__container">
      <div class="ic-sidebar__select-wrap">
        <label class="ic-sidebar__mobile-label" for="ic-sidebar__sort-filter"
          >Sort By
        </label>
        <select
          id="ic-sidebar__sort-filter"
          v-model="selectedValue"
          class="ic-sidebar__sort-dropdown"
          @change="handleSelect"
        >
          <option value="relevance" v-text="'Relevance'" />
          <option value="age-asc">Age: (1-99)</option>
          <option value="age-desc">Age: (99-1)</option>
          <option value="name-asc">Name: (A-Z)</option>
          <option value="name-desc">Name: (Z-A)</option>
        </select>
      </div>
      <slot />
      <button
        class="ic-sidebar__filter-button"
        v-touch:tap.stop.prevent="() => $emit('ic-sidebar-filter-open')"
        v-text="buttonText"
      ></button>
    </div>
  </div>
</template>

<script>
import helpers from '@/assets/js/shared/misc/helpers';
export default {
  name: 'ic-sidebar',
  data() {
    return {
      selectedValue: this.selectedOption,
      helpers
    };
  },
  watch: {
    selectedOption: function(newVal) {
      this.selectedValue = newVal;
    }
  },
  props: {
    // Selected option for the dropdown
    selectedOption: {
      type: String,
      default: 'relevance'
    },
    // Button Text - Fancy!
    buttonText: {
      type: String
    }
  },

  methods: {
    handleSelect(event) {
      this.$emit('ic-sidebar-filter-selected', event);
    },
    handleClick(event) {
      this.$emit('ic-sidebar-filter-open', event);
    },
    renderIf(condition) {
      return helpers.renderIf(condition);
    }
  }
};
</script>
